export default __webpack_public_path__ + "static/N0197-78aeb9117a65310aee3cf784b1b18f11.png";